<template>
    <div class="text-editor">
        <x-input
            v-model="this.value"
            class="x-textarea x-text-field x-text-field--placeholder"
            :class="{
                'x-input--is-focused': focused,
                'required': required,
            }"
            :rules="[textEditorRule]"
        >
            <x-label v-if="label" value>{{ label }}</x-label>

            <div class="x-text-field__slot">
                <text-editor-menu :editor="editor" />

                <editor-content class="editor" :editor="editor"/>
            </div>
        </x-input>
    </div>
</template>

<script>
    import TextEditorMenu from '~/components/Shared/UIComponents/Editor/TextEditorMenu.vue';
    import { extensions } from '~/components/Shared/UIComponents/Editor/editorConfig';
    import { Editor, EditorContent } from 'tiptap';

    export default {
        name: 'TextEditor',
        components: {
            TextEditorMenu,
            EditorContent
        },
        props: {
            value: {
                type: String,
                default: undefined
            },
            label: {
                type: String
            },
            rules: {
                type: Array,
                default: () => []
            },
            required: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                editor: null,
                focused: false
            }
        },
        mounted() {
            this.editor = new Editor({
                extensions,
                content: this.value,
                onUpdate: ({ getHTML }) => {
                    this.$emit('input', getHTML());
                },
                onFocus: () => {
                    this.focused = true;
                },
                onBlur: () => {
                    this.focused = false;
                }
            });
            this.editor.setContent(this.value);
        },
        beforeDestroy() {
            if (this.editor) {
                this.editor.destroy();
            }
        },
        watch: {
            value (val) {
                if (this.editor && val !== this.value) {
                    this.editor.setContent(val, true);
                }
            }
        },
        methods: {
            textEditorRule() {
                const ruleValue = this.value === '<p></p>' ? '' : this.value;

                if (this.rules.length > 0) {
                    for (const rule of this.rules) {
                        const ruleResult = rule(ruleValue);

                        if (typeof ruleResult === 'string') {
                            return ruleResult;
                        }
                    }
                }

                return true;
            },
        }
    }
</script>
